import React, { useEffect } from 'react';
import Row from '@amzn/meridian/row';
import { CorePage, CorePageTitle, CoreSearchTable } from '$/components';
import { RootUri } from '$/features/routes';
import ProjectsActionBar from '$/components/project/ProjectsActionBar';
import useProjectsFilters from '$/hooks/useProjectsFilters';
import { useLocation } from 'react-router-dom';
import { useClient } from '$/api';
import { ProjectColumnDefinitions } from './components/ProjectListColumnDefinitions';

const filters = [
  { key: 'name', label: 'Name', isDefault: true },
  { key: 'id', label: 'ID' },
];

export const ProjectListPage = (): JSX.Element => {
  const { projects } = useClient();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const projectsFilters = useProjectsFilters();

  useEffect(() => {
    if (!projectsFilters) return;

    const currentFilterKeys = Array.from(projectsFilters.filters.keys());

    // Convert URLSearchParams to entries manually since entries() might not be available in all environments
    const searchParamEntries: [string, string][] = [];
    const urlParamKeys: string[] = [];

    searchParams.forEach((value, key) => {
      searchParamEntries.push([key, value]);
      urlParamKeys.push(key);
    });

    // Remove filters that are no longer in the URL
    currentFilterKeys.forEach((key) => {
      if (!urlParamKeys.includes(key)) {
        projectsFilters.dispatch({
          type: 'REMOVE_FILTER',
          filter: key,
        });
      }
    });

    // Add or update filters from URL parameters
    searchParamEntries.forEach((param) => {
      const filterName = param[0];
      const paramValue = param[1];
      projectsFilters.dispatch({
        type: 'UPDATE_FILTER',
        filter: filterName,
        value: paramValue,
      });
    });
  }, [searchParams, projectsFilters]);

  return (
    <CorePage
      title="Projects"
      header={
        <Row widths="fill">
          <CorePageTitle title="Projects" />
        </Row>
      }
      breadcrumbs={[{ title: 'Storage', href: RootUri }]}
    >
      <ProjectsActionBar />
      <CoreSearchTable
        resourceKey={projects.resourceKey}
        getAll={projects.getAll}
        resourceFilters={filters}
        columns={ProjectColumnDefinitions}
        showSearch={false}
      />
    </CorePage>
  );
};
